import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/es/Field';
import { useIntl, FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import CheckboxInput from 'components/Credit24/Core/Controls/CheckboxInput';
import { fieldLevelCheckboxValidator } from 'utils/helpers';

const propTypes = {
  legalDocument: PropTypes.object.isRequired,
  bsb: PropTypes.string,
  accountNumber: PropTypes.string,
};

const SubmitAU = (props) => {
  const { legalDocument, bsb, accountNumber } = props;
  const intl = useIntl();

  // ToDo: changes keys names after PHASE II for upgrade / no-upgrade flow
  const basePrefix = 'offer.submit.confirm';
  const upgradePrefix = `${basePrefix}.upgrade`;

  const getConsentIdPrefix = (consent) => {
    const key = `${upgradePrefix}.${consent}.${legalDocument.productType}`;
    const checkTranslationKey = INCREASE_APP && Boolean(intl.messages[key]);

    return checkTranslationKey ? upgradePrefix : basePrefix;
  };

  return (
    <div className="loan-form__step legal-page">
      <div
        className="legal-page__document"
        dangerouslySetInnerHTML={{ __html: legalDocument.payload }}
      />
      <div className="legal-page__consents">
        {legalDocument.consents.map((consent) => {
          const idPrefix = getConsentIdPrefix(consent);
          return (
            <Fragment key={consent}>
              {consent === 'direct-debit'
                && (
                  <>
                    <h4 className="txt-bold">
                      <FormattedMessage id="offer.submit.confirm.direct-debit.request.title" />
                    </h4>
                    <div className="grid">
                      <div className="grid__item one-third palm-one-half">
                        <FormattedMessage id="offer.submit.confirm.direct-debit.bsb" tagName="p" />
                      </div>
                      <div className="grid__item two-thirds palm-one-half">
                        <p className="txt-bold">{bsb}</p>
                      </div>
                      <div className="grid__item one-third palm-one-half">
                        <FormattedMessage
                          id="offer.submit.confirm.direct-debit.accountNumber"
                          tagName="p"
                        />
                      </div>
                      <div className="grid__item two-thirds palm-one-half">
                        <p className="txt-bold">{accountNumber}</p>
                      </div>
                    </div>
                    <h4 className="txt-bold">
                      <FormattedMessage id="offer.submit.confirm.direct-debit.authorization.title" />
                    </h4>
                  </>
                )}
              <p>
                <Field
                  name={`offer_submit_${consent}`}
                  component={CheckboxInput}
                  validate={fieldLevelCheckboxValidator}
                  text={(
                    <FormattedHTMLMessage
                      id={`${idPrefix}.${consent}.${legalDocument.productType}`}
                    />
                  )}
                />
              </p>
              {
                consent === 'repayment-ability'
                  && (
                  <p className="legal-page__connector">
                    <FormattedMessage
                      id="offer.submit.confirm.connector"
                      tagName="p"
                      defaultMessage="and"
                    />
                  </p>
                  )
              }
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

SubmitAU.propTypes = propTypes;

export default SubmitAU;
